<script lang="ts" setup>
import { XCircleIcon } from '@heroicons/vue/solid';

interface Meta {
  valid: boolean;
  touched: boolean;
}

interface Props {
  label?: string;
  name: string;
  errorMessage: string;
  meta: Meta;
  labelPosition?: 'top' | 'left';
  labelClass?: string;
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
  name: '',
  errorMessage: '',
  labelPosition: 'top',
  labelClass: ''
});
</script>

<template>
  <div :class="{ 'has-error': !!errorMessage, success: meta.valid }">
    <div class="flex" :class="{ 'flex-col md:flex-row md:items-end md:justify-between md:gap-[16px] mt-[16px]': labelPosition === 'left', 'flex-col': labelPosition === 'top' }">
      <label v-if="label !== ''" :for="name" class="block text-white text-15 leading-[20px] font-light tracking-[0.09px]" :class="[{ ' min-w-[95px]  flex-none': labelPosition === 'left', '': labelPosition === 'top' }, labelClass]" v-html="label"></label>
      <slot></slot>
    </div>

    <Transition name="top-fade">
      <div class="mt-[4px] bg-red-100 p-[8px] rounded-[8px] flex items-center gap-[8px] z-[1]" v-if="errorMessage && meta.touched">
        <XCircleIcon class="h-[16px] fill-red-400"></XCircleIcon>
        <span class="text-12 font-semibold text-red-400">{{ errorMessage }}</span>
      </div>
    </Transition>
  </div>
</template>
